import _TopRight from 'src/layout/EditorPageLayout/TopRightBtnsGroups/TopRightBtnsGroups';
import React from 'react';
import { useHistory, useParams } from 'react-router';

const TopRight = (props) => {
  const { hasModified, onSubmit } = props;
  const { customerDatabaseUuid }: any = useParams();

  const h = useHistory();
  const onD = () => {
    h.push(`/customerDatabase/tagList/${customerDatabaseUuid}`);
  };
  return (
    <_TopRight
      onDiscard={onD}
      onSaveDisable={!hasModified}
      onSubmit={onSubmit}
    />
  );
};
export default TopRight;
